import * as React from "react";

function SignIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 16.5s.501-2.5 1-2.5 1.07 2.5 1.5 2.5c.43 0 .535-1 1-1 .465 0 .564 1 1 1 .436 0 1.5-1 1.5-1M9 7.04h6M9 9.25h6M9 11.5h6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 15,
    x: 6.5,
    y: 4.5,
    rx: 1.5
  }));
}

export default SignIcon;